import React from "react";
import { connect } from "react-redux";
import history from "../app/history";
import Logo from "../assets/images/hg_new.png";
import { Col } from "reactstrap";

const FooterNew = (props) => {
  return (
    <div className={`${props.values.loginFlag ? "" : "login-footer"}`}>
      {/* {console.log(props.values.loginFlag)} */}
      <footer className="main-footer page-footer main-footer-btc">
        <div className="footer-logo">
        <img src={Logo} alt="Logo" className="img-fluid" />
        {/* <img src={Logo} alt="Logo" className="brand-img" /> */}
          {/* <img src={OKAPI_logo} alt="Logo" className="brand-img1" /> */}
        </div>
        <div className="cust-container">
              <div className="left-box">
                 © Copyright {new Date().getFullYear()}
              <span> All right reserved. </span>  
              </div>
              {props.values.loginFlag === true && (
                <nav className="right-box">
                  <ul className="list-inline">
                    <li className="list-inline-item">
                      <p onClick={() => history.push("/home")}>Home</p>
                    </li>
                    <li className="list-inline-item">
                      <p onClick={() => history.push("/")}>About</p>
                    </li>
                    <li className="list-inline-item">
                      <p onClick={() => history.push("/")}>Products</p>
                    </li>
                    <li className="list-inline-item">
                      <p onClick={() => history.push("/")}>Contact</p>
                    </li>
                    <li className="list-inline-item">
                      <p onClick={() => history.push("/")}>Login</p>
                    </li>

                    <li className="list-inline-item">
                      <p
                        // className='btn btn-link terms'
                        onClick={() =>
                          window.open(
                            `https://lasher-test.s3.af-south-1.amazonaws.com/trialPdf/Credit+App+T%26C's+(full).pdf`
                          )
                        }
                      >
                        Terms & Conditions
                      </p>
                    </li>
                  </ul>
                </nav>
              )}
            </div>
      </footer>
    </div>
  );
};

const mapStateToProps = (state) => {
  // console.log('state', state);
  return {
    values: state.auth.login,
  };
};

export default connect(mapStateToProps)(FooterNew);
